import React, { Component } from 'react';
import interaction from '../../../../utils/interaction';
import ProgressBar from '../../shared/progress_bar';
import './List.scss';

class QuestionList extends Component {

  constructor(props){ 
    super(props);
    this.state = {
      selectedAnswers: []
    }

    this.pushSelectedAnswers = this.pushSelectedAnswers.bind(this);
  }
  
  componentDidMount() {
    interaction.animateItems();
    interaction.initSelection();
  } 

  selectAnswer(answer) {
    const selectedAnswers = this.state.selectedAnswers;
    selectedAnswers.push(answer.id);
  }

  pushSelectedAnswers() {
    this.props.next(this.state.selectedAnswers)
  }


  render() {
    const typeClass = this.props.actualQuestion.type === 'multiple' ? 'js-select-checkbox' : 'js-select-radio';
    const typeInput = this.props.actualQuestion.type === 'multiple' ? 'checkbox' : 'radio';

    return (
        <div className="select-rows">
            <div className="page__container js-select-form">
                <div className="page__top-wrapper">
                    <div className="page__text">
                        <h1>{this.props.actualQuestion.title}</h1>
                        <p className="page__desc">{this.props.actualQuestion.description}</p>
                    </div>
                    <ProgressBar questions={this.props.questions} actualQuestion={this.props.actualQuestion} type="light"/>
                </div>
                <ul className="select-rows__list">
                    {  this.props.actualQuestion.answers.map( answer => (
                        <li onClick={ this.selectAnswer.bind(this, answer) } 
                            key={answer.id}
                            className={`select-rows__list-item js-animated-item ${typeClass}`}>
                            {answer.image.length > 0 &&  <img className="select-rows__list-image" src={answer.image} alt=""></img>}
                            <span className="select-rows__list-label">{answer.title}</span>
                            <input className="hidden" type={typeInput} name="item_01" defaultValue="blank" />
                            <svg className="select-rows__list-icon" width="25" height="25">
                                <use xlinkHref="/images/sprite.svg#done" />
                            </svg>
                        </li>
                    ))}
                </ul>
                
                <div className="content-fix-button">
                  <button 
                      onClick={this.pushSelectedAnswers}
                      className="select-rows__main-button main-button main-button--white js-select-submit-button">
                      <span className="main-button__label">Continuar</span>
                      <svg className="main-button__icon" width="25" height="25">
                        <use xlinkHref="/images/sprite.svg#arrow_down"></use>
                      </svg>
                  </button>
                </div>
            </div>
        </div>
    );
  }

}

export default QuestionList;
